
import { computed, defineComponent } from "vue";
import { useSidebar } from "./utils";

export default defineComponent({
  name: "SidebarMenuButton",
  inheritAttrs: false,
  props: {
    tooltip: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "default",
    },
    isActive: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const { state, isMobile } = useSidebar();

    const sizeClass = computed(() => {
      if (props.size === "sm") return "sidebar-menu-button_size-sm";
      if (props.size === "lg") return "sidebar-menu-button_size-lg";

      return "sidebar-menu-button_size-default";
    });

    const showTooltip = computed(() => {
      if (!props.tooltip) return false;
      if (isMobile.value) return false;

      return state.value === "collapsed";
    });

    return { sizeClass, showTooltip };
  },
});
